
import {Container, Grid } from '@mui/material';
import React, { Fragment } from 'react';
import Break from '../../components/Break';
import EduCard from '../../components/Cards/EduCard';
import RenderIf from '../../components/RenderIf';
import { schools } from './helper';
import { useWindowSize, isHorizontal } from '../../helper/functions/hooks/windowsize';
import EducationFallback from './EducationFallback';

const Education = (): JSX.Element => {
    const { width, height } = useWindowSize()
    return (
        <RenderIf
            condition={isHorizontal(width, height)}
            fallback={<EducationFallback />}>
            <Container>
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center">
                    {
                        schools.map((edu, i) =>
                            <Fragment key={i}>
                                <EduCard
                                    key={i}
                                    image={edu.image}
                                    school={edu.school}
                                    degree={edu.degree}
                                    gradDate={edu.gradDate}
                                    link={edu.link} 
                                    courses={edu.courses}
                                    schoolLink={edu.schoolLink}
                                    tools={edu.tools}/>
                                <Break />
                            </Fragment>
                        )
                    }
                </Grid>
            </Container>
        </RenderIf>
    )
}
export default Education;
